import { withSubmit } from './withSubmit.hoc';
import { TextfieldNewPhoneView } from './textfield-new-phone.view';

export const TextfieldNewPhoneSubmitView = withSubmit(TextfieldNewPhoneView);
